<template>
  <div>
    <form @submit.prevent="fetch()" class="col-12">
      <div class="form-row row text-center">
        <div class="col-sm-11 col-md-5">
          <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
            class="form-control px-2" placeholder="Buscar"></b-form-input>
        </div>
        <div class="col-sm-1">
          <button type="submit" class="btn btn-primary px-2">Buscar</button>
        </div>

        <div class="col-md-4 col-sm-6">
          <form class="form-inline float-right">
            <b-form-group class="form-group" label-for="classification" label="Grupo: ">
              <b-form-input v-model="classification" disabled type="search" class="form-control ml-2"
                id="classification" placeholder=""></b-form-input>
            </b-form-group>
          </form>
        </div>

        <div class="col-sm-2">
          <form class="form-inline float-right">
            <div class="col-12 text-right m-b-0">
              <button :disabled="!getRole('Crear')" class="btn btn-primary ml-1" @click="goRegisterPage">
                Agregar
              </button>
            </div>
          </form>
        </div>
      </div>
    </form>

    <div v-if="!loading">
      <table
        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
        <thead class="table-active">
          <tr>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1">
              Ítem
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-6">
              Nombre
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Valor en el estándar
            </th>
            <th scope="col" class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Estado
            </th>
            <th scope="col" class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Obligatorio
            </th>
            <th scope="col" class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in visibleItems" :key="item.id" :class="{ 'disabled-row': isDisabledRow(item) }">
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ item.sequence }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              <b v-if="item.url === 'url'">
                {{ item.description }}
              </b>
              <router-link v-else :to="putIDonURL(item.url)">
                <b>{{ item.description }}</b>
              </router-link>
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ item.value }}
            </td>
            <td class="text-center">
              <span v-if="isNoAplica(item)" class="badge badge-soft-secondary">
                No aplica
              </span>
              <span v-else-if="item.companies[0] == null" class="badge badge-soft-danger">
                No cumplido
              </span>
              <span v-else-if="item.companies[0].pivot.status == 'Aprobado'" class="badge badge-soft-success">
                Aprobado
              </span>
              <span v-else-if="item.companies[0].pivot.status == 'Pendiente'" class="badge badge-soft-warning">
                Pendiente
              </span>
              <span v-else-if="item.companies[0].pivot.status == 'No cumplido'" class="badge badge-soft-danger">
                No cumplido
              </span>
              <span v-else-if="item.companies[0].pivot.status == 'No aplica'" class="badge badge-soft-secondary">
                No aplica
              </span>
            </td>
            <td class="text-center px-6 text-sm text-gray-500 mx-2">
              <div>
                <i :class="`mdi ${getObligatory(item) ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'
                  } mdi-18px text-primary`"></i>
                <div v-if="isComplementary(item)" class="badge badge-soft-info mt-1">
                  Complementario
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="col-sm-12">
                <b-dropdown variant="primary" :disabled="!getRole('Editar') || isNoAplica(item)">
                  <template v-slot:button-content>
                    <i class="mdi mdi-eye"></i>
                  </template>
                  <b-dropdown-item :disabled="!getRole('Editar') || isNoAplica(item)"
                    :to="{ path: `/forms/editar-item/${item.id}` }">
                    Editar
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="text-center pt-2">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
    <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
      @fetch="(items) => (standardItems = items)" />
  </div>
</template>

<script>
import Pagination from "./StandardPagination";
import CheckModal from "@/components/CheckModal";
import { canAccessItemSequence } from "@/helpers/roles";

export default {
  components: { Pagination, CheckModal },
  props: {
    companyID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      standardItems: [],
      search: null,
      loading: true,
      classification: this.$store.getters["company/getCompany"].company_classification_id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      itemsImplemented: [],
    };
  },
  computed: {
    // Filtra items para Talento Humano segun la lista permitida.
    // Para los demas roles devuelve la lista completa.
    visibleItems() {
      return this.standardItems.filter(item => canAccessItemSequence(item.sequence))
    },
  },
  methods: {
    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess(item) {
      try {
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Permitir a todos los roles que tengan permisos asignados.
          // El gate real es el permission check de abajo (enabled).
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    isNoAplica(item) {
      return (
        (this.classificationID === 1 && item.obligatory_UPA === 0) ||
        (this.classificationID === 2 && item.obligatory_groupI === 0) ||
        (this.classificationID === 3 && item.obligatory_groupII === 0) ||
        (this.classificationID === 4 && item.obligatory_groupIII === 0)
      );
    },

    isDisabledRow(item) {
      return this.isNoAplica(item);
    },

    putIDonURL(url) {
      const regex = /:id/i;
      return url.replace(regex, this.companyID);
    },

    // Obligatorio = la Res. 0312 se lo exige al grupo. Los ítems que le aplican
    // pero la norma no le exige (complementarios) quedan sin marcar: se pueden
    // diligenciar, pero no cuentan para el porcentaje de cumplimiento por norma.
    getObligatory(item) {
      return (
        (this.classificationID === 1 && item.by_norm_UPA === 1) ||
        (this.classificationID === 2 && item.by_norm_groupI === 1) ||
        (this.classificationID === 3 && item.by_norm_groupII === 1) ||
        (this.classificationID === 4 && item.by_norm_groupIII === 1)
      );
    },

    // Complementario: le aplica al grupo pero no es exigido por norma.
    isComplementary(item) {
      return !this.isNoAplica(item) && !this.getObligatory(item);
    },

    goRegisterPage() {
      this.$router.push({
        name: "registro-item",
        params: {
          id: this.$route.params.id,
        },
      });
    },

    setClassification() {
      if (this.classificationID === 1) {
        this.classification = "UPA";
      } else if (this.classificationID === 2) {
        this.classification = "I";
      } else if (this.classificationID === 3) {
        this.classification = "II";
      } else if (this.classificationID === 4) {
        this.classification = "III";
      } else {
        this.classification = "No definido";
      }
    },
  },
  mounted() {
    this.fetch();
    this.setClassification();
  },
};
</script>

<style>
.disabled-row {
  pointer-events: none;
  opacity: 0.6;
}
</style>
